import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { driversSelector } from 'reduxModules/selectors/GlobalSelectors'
import { globalActions } from 'reduxModules/actions/GlobalActions'
import withSorting from 'hoc/withSorting'

import { DriversBase } from './Drivers'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  drivers: driversSelector,
})

const mapDispatchToProps = {
  setDriver: globalActions.setDriver,
  deleteDriver: globalActions.deleteDriver,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  withSorting
)

export const Drivers = enhance(DriversBase)



// WEBPACK FOOTER //
// ./src/components/Drivers/index.js